import { v4 as uuidv4 } from "uuid";

export class GuestIdHelper {
  public static readonly getGuestId = (): string | null => localStorage.getItem("sgGuestId");

  public static readonly setGuestId = (guestId: string): void => localStorage.setItem("sgGuestId", guestId);

  public static readonly clearGuestId = (): void => localStorage.removeItem("sgGuestId");

  public static readonly getOrCreateGuestId = () => {
    const guestId = this.getGuestId();
    if (guestId) {
      return guestId;
    }

    const newGuestId = uuidv4();
    this.setGuestId(newGuestId);

    return newGuestId;
  };
}
